declare const __APPLENS_WEB_VERSION__: string;

// CRACO injects installed package metadata, not a user-controlled environment value.
export const SDK_VERSION =
  typeof __APPLENS_WEB_VERSION__ === "string" ? __APPLENS_WEB_VERSION__ : "";

export function sdkCapabilities(version: string) {
  // Reviewed 0.1.0 contract: beta.2 adds opt-in propagation and policy-preserving renewal.
  // Future release lines need contract review rather than assuming API compatibility.
  const match = /^0\.1\.0(?:-beta\.([1-9][0-9]*))?$/.exec(version);
  const supported = !!match && (!match[1] || Number(match[1]) >= 2);
  return { deploymentPropagation: supported, renewLease: supported };
}
